export default __webpack_public_path__ + "static/media/ra-radio.64461bab.svg";